import React from 'react';
import poster from '../../Assets/videoPoster.png';

const FullWidthVideo = ({ vidLink }) => {
  return (
    <div className="fullWidthVid">
      <video playsInline width="320" poster={poster} height="240" controls>
        <source src={vidLink} type="video/mp4" />
      </video>
    </div>
  );
};

export default FullWidthVideo;
